import EmojiAndProgressbar from "./EmojiAndProgressbar";
import ProgressBar from "components/Progressbar";
import UserDefaultAvatar from "assets/img/user.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoffee, faComment } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

const styles = {
  teamVideo: {
    marginTop: "10px",
    margin: "5px",
  },
  video: {
    width: "100%",
    background: "#ccc",
    height: "120px",
    objectFit: "cover",
  },
  timeFilter: {
    height: "35px",
  },
  teamVideoHeader: {
    display: "flex",
    padding: "5px",
  },
  teamVideoFooter: {
    display: "flex",
    padding: "5px",
    justifyContent: "space-between",
    fontSize: "12px",
    alignItems: "center",
    position: "relative",
  },
  publishedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  avatar: {
    minHeight: "40px",
    height: "40px",
    minWidth: "40px",
    width: "40px",
    borderRadius: "50%",
    cursor: "pointer",
  },
};

const checkInpercentage = {
  paddingLeft: "3px",
  color: "black",
  fontSize: "12px",
  paddingTop: "4px",
};
const CheckInStatsDetailCard = ({ userStats }) => {
  const classes = styles;
  let history = useHistory();

  const showUserProfile = (id) => {
    history.push(`/profile/${id}`);
  };

  return (
    <div className="sidebar-post user-stats" key={userStats.id}>
      <div className="user-stats-header">
        <img
          onClick={() => showUserProfile(userStats?.id)}
          style={classes.avatar}
          src={userStats.avatar ?? UserDefaultAvatar}
          alt={`${userStats.id}`}
        />
        <h6>
          <strong>{userStats?.full_name}</strong>
        </h6>
        <FontAwesomeIcon icon={faComment} className="checkinRightSideIcon" />
        <FontAwesomeIcon
          className="ms-2 checkinRightSideIcon"
          icon={faCoffee}
        />
      </div>
      <div className="p-l-10">
        <h6 className="orange-clr txt-progress mt-2">Happiness Meter</h6>
        <h6 className="color-parrot txt-progress">
          {`${userStats.meter}% Good Mood`}
        </h6>
        <ProgressBar
          completed={userStats.meter}
          progressBackgroundColor="#e0e0de"
          bgcolor={"#A8CF45"}
        />
        <div>
          <EmojiAndProgressbar
            color={"black"}
            checkstats={userStats.moods}
            bgcolor={"#A8CF45"}
            classPercentage={checkInpercentage}
          />
        </div>
      </div>
    </div>
  );
};
export default CheckInStatsDetailCard;
